import type { IDataIndicator, IGetIndicatorListParams } from '../types/index';

export abstract class CoverageApi {
    abstract getIndicatorList(params?: IGetIndicatorListParams): Promise<IDataIndicator[]>;
}
